import ComponentTypes from '@theme-original/NavbarItem/ComponentTypes';
import SmartLocaleDropdownNavbarItem from '@site/src/components/SmartLocaleDropdownNavbarItem';

export default {
  ...ComponentTypes,
  'custom-smartLocaleDropdown': SmartLocaleDropdownNavbarItem,
};
